"use strict";
// 启动服务相关工具函数与纯函数逻辑模块
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServerPaths = getServerPaths;
exports.checkPM2Installed = checkPM2Installed;
exports.checkServerOnline = checkServerOnline;
exports.installPM2 = installPM2;
exports.startAgentServerWithPM2 = startAgentServerWithPM2;
exports.checkServerStatus = checkServerStatus;
const path = __importStar(require("path"));
const cli_core_1 = require("@/cli-core");
/**
 * 获取产物目录路径
 * @returns 包含 serverPath 和 serverDir 的对象
 */
function getServerPaths() {
    const distIndex = __dirname.indexOf('dist');
    const distDir = distIndex !== -1 ? __dirname.substring(0, distIndex + 4) : path.resolve(__dirname, '../../..');
    return {
        serverPath: path.join(distDir, 'server/main.js'),
        serverDir: path.join(distDir, 'server'),
    };
}
/**
 * 检查系统全局是否已安装 PM2
 * @returns 是否安装的布尔值
 */
async function checkPM2Installed() {
    const res = await cli_core_1.ChildProcess.runCmdAsync('pm2 -v');
    return res.status === 'success';
}
/**
 * 检查 Agent Server 是否已经在 PM2 中处于 online 状态
 * @param serverName 服务名称
 * @returns 是否在线的布尔值
 */
async function checkServerOnline(serverName) {
    const { serverDir } = getServerPaths();
    const res = await cli_core_1.ChildProcess.runCmdAsync('pm2 jlist', serverDir);
    if (res.status === 'success') {
        try {
            const list = JSON.parse(res.data);
            const target = list.find((p) => p.name === serverName);
            return target && target.pm2_env && target.pm2_env.status === 'online';
        }
        catch {
            return false;
        }
    }
    return false;
}
/**
 * 全局安装 PM2 进程守护工具
 * @returns 安装是否成功
 */
async function installPM2() {
    const isWindows = process.platform === 'win32';
    let installRes;
    if (isWindows) {
        installRes = await cli_core_1.ChildProcess.runCmdAsync('npm install -g pm2', process.cwd());
    }
    else {
        cli_core_1.CLI.loading.info('非 Windows 系统全局安装 PM2 需要管理员权限，请根据系统提示输入密码：');
        installRes = await cli_core_1.ChildProcess.runCmdAsync('sudo npm install -g pm2', process.cwd());
        if (installRes.status !== 'success') {
            installRes = await cli_core_1.ChildProcess.runCmdAsync('npm install -g pm2', process.cwd());
        }
    }
    return installRes.status === 'success';
}
/**
 * 封装的 Agent Server 启动函数（基于 PM2 常驻后台并自动保存状态）
 * @param port 端口号
 * @param serverName 服务名称
 * @returns 启动是否成功
 */
async function startAgentServerWithPM2(port, serverName) {
    const { serverPath, serverDir } = getServerPaths();
    cli_core_1.CLI.loading.start(`正在通过 PM2 守护进程启动 ${serverName} (端口: ${port})...`);
    // 临时注入环境变量供子进程继承
    process.env.PORT = port;
    try {
        const describeRes = await cli_core_1.ChildProcess.runCmdAsync(`pm2 describe ${serverName}`, serverDir);
        cli_core_1.CLI.loading.succeed('正在唤起 PM2 进程守护...');
        if (describeRes.status === 'success') {
            // 如果已存在则直接重启并更新环境变量
            await cli_core_1.ChildProcess.runCmdLive(`pm2 restart ${serverName} --update-env`, serverDir);
        }
        else {
            // 若不存在则通过 PM2 新建并常驻后台
            await cli_core_1.ChildProcess.runCmdLive(`pm2 start "${serverPath}" --name "${serverName}"`, serverDir);
        }
        // 成功启动后，执行 pm2 save 保存当前进程状态
        cli_core_1.CLI.loading.start('正在保存 PM2 进程状态...');
        await cli_core_1.ChildProcess.runCmdAsync('pm2 save', serverDir);
        cli_core_1.CLI.loading.succeed(`${serverName} 已成功通过 PM2 常驻后台运行并完成状态保存！`);
        cli_core_1.CLI.loading.info(`提示: 可通过终端执行 \`pm2 status\` 查看状态，执行 \`pm2 logs ${serverName}\` 查看运行日志。`);
        return true;
    }
    catch (err) {
        cli_core_1.CLI.loading.fail(`通过 PM2 启动服务失败: ${err.message}`);
        return false;
    }
}
/**
 * 检查服务在 PM2 中的运行状态（判断是否存在及是否 online）
 * @param serverName 服务名称
 * @returns 包含 exists 和 online 状态的对象
 */
async function checkServerStatus(serverName) {
    const res = await cli_core_1.ChildProcess.runCmdAsync('pm2 jlist');
    if (res.status === 'success') {
        try {
            const list = JSON.parse(res.data);
            const target = list.find((p) => p.name === serverName);
            if (target) {
                return {
                    exists: true,
                    online: target.pm2_env && target.pm2_env.status === 'online',
                };
            }
        }
        catch {
            return { exists: false, online: false };
        }
    }
    return { exists: false, online: false };
}
